import { useEffect, useState } from 'react';

import { KeyCodes } from '../utils/keyCodes';

export const FOCUSABLE_ELEMENT_SELECTORS =
  'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, [tabindex="0"], [contenteditable]';

const manageFocus = (ref, triggered) => {
  if (triggered && ref.current) {
    const focusableElements = ref.current.querySelectorAll(
      FOCUSABLE_ELEMENT_SELECTORS,
    );

    if (focusableElements.length > 0) {
      const firstFocusableEl = focusableElements[0];
      const lastFocusableEl = focusableElements[focusableElements.length - 1];

      return { first: firstFocusableEl, last: lastFocusableEl };
    }
  }

  return { first: null, last: null };
};

const useFocusTrap = (ref) => {
  const [triggered, setTriggered] = useState(false);

  useEffect(() => {
    const handleKeyDown = (ev) => {
      if (ev.keyCode === KeyCodes.tab) {
        if (!triggered) {
          setTriggered(true);
        }

        const { first, last } = manageFocus(ref, triggered);

        if (
          ev.shiftKey &&
          last &&
          (document.activeElement === first ||
            document.activeElement === ref.current)
        ) {
          ev.preventDefault();
          last.focus();
        } else if (!ev.shiftKey && first && document.activeElement === last) {
          ev.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [triggered, ref]);
};

export default useFocusTrap;
